import React from 'react'

export const TesterMode = () => {
    const testerMode = process.env.REACT_APP_ENVIRONMENT_TEST === 'true';

    return (
        <>
            { testerMode &&
                <div style={{ backgroundColor: '#ffd000', padding: '7px', fontSize: '14px', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>
                    Você está em um Ambiente de TESTE! Todas as ações executadas aqui não possuem efeito no Ambiente de Produção.
                </div>
            }
        </>
    )
}

export default TesterMode;